import { ADMIN_API_URL } from "../../utils/env";

export type MakerEnvironment = "mainnet" | "testnet";
export function makerEnvironment(): MakerEnvironment | undefined {
  const environment = process.env.REACT_APP_ENVIRONMENT;
  try {
    const { origin } = new URL(ADMIN_API_URL("makers/state"));
    if (environment === "mainnet" && origin === "https://admin-api.aevo.xyz")
      return "mainnet";
    if (
      ["testnet", "local"].includes(environment || "") &&
      (origin === "https://admin-api-testnet.aevo.xyz" ||
        (environment === "local" && origin === "http://localhost:8080"))
    )
      return "testnet";
  } catch {
    /* Unknown or missing endpoint fails closed. */
  }
  return undefined;
}
export function makerEnvironmentMatches(data: {
  environment?: unknown;
  testnet_only?: unknown;
}) {
  const expected = makerEnvironment();
  return (
    !!expected &&
    data.environment === expected &&
    data.testnet_only === (expected === "testnet")
  );
}
